import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center px-6 md:px-12 overflow-hidden bg-navy" data-id="element-49" data-mp="eilghbqnn7g7">
      {/* Faint compass mark in background corner */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 opacity-[0.04] pointer-events-none" data-id="element-50" data-mp="4mrtszj81xkp">
        <Compass className="w-[700px] h-[700px] text-cream" strokeWidth={0.5} data-id="element-51" data-mp="128z0cez35zzp" />
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10 mt-20" data-id="element-52" data-mp="xbp8yts4ze98">
        <FadeIn delay={0.2} data-id="element-53" data-mp="sai4b3laiv6s">
          <div className="flex items-center space-x-4 mb-10" data-id="element-54" data-mp="s9q75oc1opee">
            <div className="w-10 h-[1px] bg-gold" data-id="element-55" data-mp="ncq31iyr9wpx"></div>
            <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-gold" data-id="element-56" data-mp="neawt6d8xbmq">
              Wyoming · Estados Unidos · Fundada en 2025
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.35} data-id="element-57" data-mp="384jtl03lnltg">
          <h1 className="font-display text-7xl md:text-9xl lg:text-[11rem] text-cream leading-[0.85] tracking-tighter mb-10" data-id="element-58" data-mp="3j8sgk46tfprf">
            BPF LLC
          </h1>
        </FadeIn>

        <FadeIn delay={0.55} data-id="element-59" data-mp="3o59cvlo65afl">
          <div className="max-w-3xl" data-id="element-60" data-mp="39autvl4lu10x">
            <p className="text-xl md:text-2xl text-cream/90 font-light leading-relaxed mb-6" data-id="element-61" data-mp="399ti1efrlai5">
              Democratizamos el conocimiento a través de libros digitales
              accesibles para todo el mundo.
            </p>
            <p className="text-base md:text-lg text-muted font-light leading-relaxed" data-id="element-62" data-mp="30g6oluz14jc4">
              Una compañía 100% online dedicada a la edición y distribución de
              libros digitales, especialistas en el armado de funnels Low Ticket
              a través de Meta Ads.
            </p>
          </div>
        </FadeIn>
      </div>

      
    </section>;
}